import React from "react";
import {connect} from "react-redux";
import {formValueSelector, reduxForm} from "redux-form";
import {ff, form} from "@mc/mc-legacy";
import {Button, Col, Row} from "reactstrap";
import * as TypDokladu from "mc/lib/api/gen/subjekty/v1/TypDokladu";
import {HorizontalLoader} from "@mc/mc-legacy";
import {i18n} from "../../i18n/i18n";
import {withLang} from "../../i18n/withLang";
import "./Form.scss";
import * as TypOvereniSubjektu from "../../api/TypOvereniSubjektuInfo";


const DokladForm = (props) => {
    const {handleSubmit, error, submitting, typOvereniSubjektu} = props;
    return (
        <form.Form className={"form"} horiznotal onSubmit={handleSubmit}>
            <form.FormBody>
                {error && <form.ValidationErrors error={error}/>}
                <Row>
                    <Col xs={12} className={"mb-3"}>
                        <h5>{i18n(props.lang, "TypOvereniSubjektu")}</h5>
                        <ff.Select
                            className={"py-10"}
                            name="typOvereniSubjektu"
                            field={false}
                            disabled={submitting}
                        >
                            <option value={""} key={"_null_"}/>
                            {TypOvereniSubjektu.values.map((v) => (
                                <option value={v} key={v}>
                                    {i18n(props.lang, `TypOvereniSubjektu_${v}`)}
                                </option>
                            ))}
                        </ff.Select>
                    </Col>
                </Row>
                <div className={"mt-3"}/>
                {typOvereniSubjektu === TypOvereniSubjektu.DOKLAD_CISLO && <Row>
                    <Col xs={12} md={6} className={"mb-3"}>
                        <ff.Select
                            className={"py-10"}
                            field={false}
                            name="typDokladu"
                            defaultValue={TypDokladu.RP}
                            disabled={submitting}
                        >
                            {DokladForm.formTypDokladu.map((v) => (
                                <option value={v} key={v}>
                                    {i18n(props.lang, `TypDokladu_${v}`)}
                                </option>
                            ))}
                        </ff.Select>
                    </Col>
                    <Col xs={12} md={6}>
                        <ff.String
                            label={false}
                            name={"idDoklad"}
                            className={"rounded-left-0 over py-10"}
                            placeholder={i18n(props.lang, "DokladForm_cisloDokladu")}
                            required
                            disabled={submitting}
                        />
                    </Col>
                </Row>}
                {typOvereniSubjektu === TypOvereniSubjektu.JMENO_PRIJMENI_DATUMNAR && <div>
                    <Row>
                        <Col xs={12} md={8} className={"mb-3"}>
                            <ff.String
                                label={false}
                                name={"jmeno"}
                                className={"rounded-left-0 over py-10"}
                                placeholder={i18n(props.lang, "DokladForm_jmeno")}
                                required
                                disabled={submitting}
                            />
                        </Col>
                        <Col xs={12} md={8} className={"mb-3"}>
                            <ff.String
                                label={false}
                                name={"prijmeni"}
                                className={"rounded-left-0 over py-10"}
                                placeholder={i18n(props.lang, "DokladForm_prijmeni")}
                                required
                                disabled={submitting}
                            />
                        </Col>
                        <Col xs={12} md={6} className={"mb-3"}>
                            <ff.SimpleDate
                                label={false}
                                name={"datumNarozeni"}
                                className={"rounded-left-0 over py-10"}
                                placeholder={i18n(props.lang, "DokladForm_datumNarozeni")}
                                required
                                disabled={submitting}
                            />
                        </Col>
                    </Row>
                </div>}
            </form.FormBody>
            <form.FormActions submitButton={false}>
                <Button disabled={submitting || !typOvereniSubjektu} className={"btn btn-primary py-15"}>
                    {i18n(props.lang, "button_Pokracovat")}
                </Button>
            </form.FormActions>
        </form.Form>
    );
};

DokladForm.formTypDokladu = TypDokladu.values.filter((t) => t !== TypDokladu.OSTATNI && t !== TypDokladu.RP);

DokladForm.validate = (formData, props) => {
    const errors = {};

    if (!formData.typOvereniSubjektu) {
        errors.typOvereniSubjektu = i18n(props.lang, "DokladForm_typOvereniSubjektu_required");
    }

    if (formData.typOvereniSubjektu === TypOvereniSubjektu.DOKLAD_CISLO) {
        if (!formData.idDoklad) {
            errors.idDoklad = i18n(props.lang, "DokladForm_idDoklad_required");
        } else if (formData.idDoklad.length > 9) {
            errors.idDoklad = i18n(props.lang, "DokladForm_idDoklad_maxLength");
        } else if (formData.idDoklad.length < 8) {
            errors.idDoklad = i18n(props.lang, "DokladForm_idDoklad_minLength");
        }

        if (!formData.typDokladu) {
            errors.typDokladu = i18n(props.lang, "DokladForm_typDokladu_required");
        }
    } else if (formData.typOvereniSubjektu === TypOvereniSubjektu.JMENO_PRIJMENI_DATUMNAR) {
        if (!formData.jmeno) {
            errors.jmeno = i18n(props.lang, "DokladForm_jmeno_required");
        }
        if (!formData.prijmeni) {
            errors.prijmeni = i18n(props.lang, "DokladForm_prijmeni_required");
        }
        if (!formData.datumNarozeni) {
            errors.datumNarozeni = i18n(props.lang, "DokladForm_datumNarozeni_required");
        }
    }

    return errors;
};

const DokladFormForm = reduxForm({
    form: "dokladForm",
    validate: DokladForm.validate,
})(DokladForm);

function mapStateToProps(state, props) {
    const formName = props.form || "dokladForm";
    const selector = formValueSelector(formName);
    return {
        typOvereniSubjektu: selector(state, "typOvereniSubjektu"),
    };
}

export default withLang(connect(mapStateToProps)(DokladFormForm));
